import type { FC, PropsWithChildren } from 'react';

import * as S from './Body.styles';

export const BodyModal: FC<PropsWithChildren> = ({ children }) => {
  return <S.BodyWrapper>{children}</S.BodyWrapper>;
};
